<div class="info-box p-kh-3 bg-kh-grey-warm-lightest">
    <ng-content></ng-content>
</div>
